import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DiscountServiceService {

  constructor() {}

  convertUTCDateToLocalAlgOffset(date:any) {

    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    var AlgOffset = date.getTimezoneOffset() / 60;

    var hours = date.getHours();

    newDate.setHours(hours - AlgOffset);

    return newDate;
  }

}
